module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAnCAMAAAB6+uurAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF0ubd2eriyNDM2tvb6enp8/TzydfQzN3V6vLtz+LZ/P384eHi9fj20dHR////3u7p18dMuAAAANtJREFUeNq81FkOgzAMRVGbTA4EZ/+7rUkHRAslD6m9EnxxMhABqWpRKLIrE3OtVUR6SVmev0dkuvllABmPiNSjqMXPUdpA4TvZictCKpTChNosjJAsMKmNELiZS6QwTKT+mrCR+hfCfyHgsWScJKURJ+hJXiAR3UnbPkrsfVko8fNgxRhTStn+QB1kmjedejt9Nx/38Pz2vRTv/eTcNxk/vv1XIYR9n2weyntk08bb6uyWT8ja+HpDg22Le4iO60KH1EeWeVyRO4x95JF4Uw4ilseJhhkmGvQmwAA2hWfi3NzmjwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/SD.png
// module id = 9eGX
// module chunks = 1